import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const CheckboxItem = ({
	id,
	label,
	name,
	value,
	checked = false,
	onChange = undefined,
	type = "checkbox",
	disabled = false
}) => (
	<div
		className={classNames("filters__checkbox-row", {
			"filters__checkbox-row--disabled": disabled
		})}
	>
		<input
			id={id}
			name={name}
			value={value}
			type={type}
			// GTM click class reflects the pre-toggle state so it names the action a click performs.
			className={classNames(
				type === "radio"
					? "filters__radio-input"
					: "filters__checkbox-input",
				checked ? "filters__option-deselect" : "filters__option-select"
			)}
			checked={checked}
			onChange={onChange}
			disabled={disabled}
		/>
		<label
			className={classNames("filters__checkbox-label", {
				"filters__checkbox-label--disabled": disabled
			})}
			htmlFor={id}
		>
			{label}
		</label>
	</div>
);

CheckboxItem.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	type: PropTypes.oneOf(["checkbox", "radio"]),
	disabled: PropTypes.bool
};

export default CheckboxItem;
